import React, { useMemo, useRef, useState } from "react";
import PopUpScreen from "../../component/popUpScreen/popUpScreen";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import accessManagementService from "../../services/accessManagementService";
import { useQuery } from "@tanstack/react-query";

import { Skeleton } from "primereact/skeleton";
import { ChangeRolePermissionApi } from "../../mutations/AccessManagementMutationHook";
import { useToast } from "../../context/ToastContext";

function ChangeMemberRolePermissionDialog({
  onHide,
  userIds = [],
}) {
  const toast = useToast();
  const [selectedAccess, setselectedAccess] = useState({});

  const { data: allRoles = [], isLoading: isAllRolesDataLoading } = useQuery({
    queryKey: ["getAllUserRolePermisssions"],
    queryFn: () => accessManagementService.getAllRolesPermission(),
  });

  const closeDialog = () => {
    onHide();
  };

  const roleOptionTobeShown = useMemo(() => {
    if (userIds.length === 1) {
      console.log(userIds[0]);

      return allRoles.filter(
        (role) => role.permission !== userIds[0].role_permission_name
      );
    }

    return allRoles;
  }, [allRoles, userIds]);
  console.log(roleOptionTobeShown);

  const { mutate: changeRolePermissionApi, isPending: isChangingRole } =
    ChangeRolePermissionApi(
      () => {
        toast({
          severity: "info",
          summary: "Confirmed",
          detail: `Permission was  updated successfully`,
          life: 3000,
        });
        onHide();
      },
      (error) => {
        toast({
          severity: "info",
          summary: "Error",
          detail: error.response.data.detail,
          life: 3000,
        });
      }
    );

  const changeRole = () => {
    changeRolePermissionApi({
      updates: userIds.map((user) => {
        return {
          user_id: user.user_id,
          role_permission_id: selectedAccess.role_permission_id,
          last_modified_by: localStorage.getItem("userId"),
          data_asset_id: user.data_asset_id,
        };
      }),
    });
  };

  const { data: userDetails = [], isLoading: isUserDetailsLoading } = useQuery({
    queryKey: ["getUserDetails"],
    queryFn: () => accessManagementService.getLoggedInUserDetails(),
  });

  if (isUserDetailsLoading) {
    return (
      <PopUpScreen
        closable={false}
        header="Change Member Permission"
        onHide={closeDialog}
        style={{ width: "30%" }}
      >
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <Skeleton height="2rem" className="my-1"></Skeleton>
        <div className="flex gap-4 justify-content-end">
          <Skeleton height="3rem" width="5rem" className="my-1"></Skeleton>
          <Skeleton height="3rem" width="5rem" className="my-1"></Skeleton>
        </div>
      </PopUpScreen>
    );
  }

  return (
    <PopUpScreen
      closable={false}
      header="Change Member Permission"
      onHide={closeDialog}
      style={{ width: "30%" }}
    >
      <div className="grid">
        <div className="col-12">
          <Dropdown
            loading={isAllRolesDataLoading}
            style={{ width: "100%", marginBottom: "5px" }}
            value={selectedAccess}
            onChange={(e) => setselectedAccess(e.value)}
            options={roleOptionTobeShown}
            optionLabel="permission"
            placeholder="Select the Permission"
            className="w-full "
          />

          {/* <ErrorMessage  message={"dsfs"} /> */}
        </div>
      </div>
      <div className="grid">
        <div className="col-12" style={{ textAlign: "right" }}>
          <Button
            disabled={isChangingRole}
            label="Cancel"
            style={{ marginRight: "10px" }}
            onClick={() => closeDialog()}
            outlined
          />
          <Button
            disabled={isChangingRole || !Object.keys(selectedAccess).length}
            loading={isChangingRole}
            label="Save"
            onClick={changeRole}
          />
        </div>
      </div>
    </PopUpScreen>
  );
}

export default ChangeMemberRolePermissionDialog;
